<div class="row">
  <div class="col-sm-2">
    <b>Location Name</b>
  </div>
  <div class="col-sm-4">
    <input type="text"
           [(ngModel)]="loc.locationName"
           class="form-control">
  </div>
  <div class="col-sm-2">
    <b>Location Key</b>
    <p>
      location key is typically city state zip
    </p>
  </div>
  <div class="col-sm-4">
    <input type="text"
           [(ngModel)]="loc.locationKey"
           class="form-control">
  </div>
</div>
<br>
<div class="row">
  <div class="col-sm-2">
    <b>Tagline</b>
  </div>
  <div class="col-sm-4">
    <input type="text"
           [(ngModel)]="loc.tagline"
           class="form-control">
  </div>
  <!-- <div class="col-sm-2">
    <b>Managers Name</b>
  </div>
  <div class="col-sm-4">
    <input type="text"
           [(ngModel)]="loc.managersName"
           class="form-control">
  </div> -->
</div>
<br>
<!-- <div class="row">
  <div class="col-sm-2">
    <b># Units</b>
  </div>
  <div class="col-sm-4">
    {{ loc.numUnits }}
  </div>
  <div class="col-sm-2">
    <b>Occupancy</b>
  </div>
  <div class="col-sm-4">
    {{ loc.occupancyRate }}
  </div>
</div> -->
<br>
<div class="row">
  <div class="col-sm-2">
    <b>Email</b>
  </div>
  <div class="col-sm-4">
    <input type="text"
           [(ngModel)]="loc.email"
           class="form-control">
  </div>
  <div class="col-sm-2">
    <b>phone</b>
  </div>
  <div class="col-sm-4">
    <input type="text"
           [(ngModel)]="loc.phone"
           class="form-control">
  </div>
</div>
<br>
<div class="row">
  <div class="col-sm-2">
    <b>Sitelink Corp Code</b>
  </div>
  <div class="col-sm-4">
    <input type="text"
           [(ngModel)]="loc.sitelinkCorpCode"
           class="form-control">
  </div>
  <div class="col-sm-2">
    <b>Sitelink Location Code</b>
  </div>
  <div class="col-sm-4">
    <input type="text"
           [(ngModel)]="loc.sitelinkLocationCode"
           class="form-control">
  </div>
</div>
<br>
<div class="row">
  <div class="col-sm-2">
    <b>Hours</b>
  </div>
  <div class="col-sm-4">
    <textarea [(ngModel)]="loc.hours"
              class="form-control"></textarea>
  </div>
  <div *ngIf="loc.accessHours"
       class="col-sm-2">
    <b>Access Hours</b>
  </div>
  <div *ngIf="loc.accessHours"
       class="col-sm-4">
    <textarea [(ngModel)]="loc.accessHours"
              class="form-control"></textarea>
  </div>
  <div class="col-sm-2">
    <b>Address</b>
  </div>
  <div class="col-sm-4">
    <input type="text"
           [(ngModel)]="loc.address1"
           class="form-control"><br>
    <input type="text"
           [(ngModel)]="loc.address2"
           class="form-control">
  </div>
</div>

<br>
<div class="row">
  <div class="col-sm-2">
    <b>Social Media</b>
  </div>
  <div class="col-sm-4">
    <a *ngIf="loc.isFb"
       class="link"
       href="{{loc.fbUrl}}"
       target="_blank"><img *ngIf="loc.isFb"
           src="https://www.storagepug.com/hubfs/Social%20Media%20Icons/Shadow/Facebook.png"
           alt=""
           class="onboarding-social"></a>
    <a *ngIf="loc.isTwitter"
       class="link"
       href="{{loc.twitterUrl}}"
       target="_blank"><img *ngIf="loc.isTwitter"
           src="https://www.storagepug.com/hubfs/Social%20Media%20Icons/Shadow/Twitter.png"
           alt=""
           class="onboarding-social"></a>
    <a *ngIf="loc.isYelp"
       class="link"
       href="{{loc.yelpUrl}}"
       target="_blank"><img *ngIf="loc.isYelp"
           src="https://www.storagepug.com/hubfs/Social%20Media%20Icons/Shadow/Yelp.png"
           alt=""
           class="onboarding-social"></a>
    <a *ngIf="loc.isGoogle"
       class="link"
       href="{{loc.google}}"
       target="_blank"><img *ngIf="loc.isGoogle"
           src="https://www.storagepug.com/hubfs/Social%20Media%20Icons/Shadow/Google%20Plus.png"
           alt=""
           class="onboarding-social"></a>
    <a *ngIf="loc.isLinkedIn"
       class="link"
       href="{{loc.linkedIn}}"
       target="_blank"><img *ngIf="loc.isLinkedIn"
           src="https://www.storagepug.com/hubfs/Social%20Media%20Icons/Shadow/LinkedIn.png"
           alt=""
           class="onboarding-social"></a>
    <a *ngIf="loc.isInsta"
       class="link"
       href="{{loc.insta}}"
       target="_blank"><img *ngIf="loc.isInsta"
           src="https://www.storagepug.com/hubfs/Social%20Media%20Icons/Shadow/Instagram.png"
           alt=""
           class="onboarding-social"></a>
    <br>

  </div>
  <div *ngIf="!isTypeform"
       class="col-sm-6">

    <input *ngIf="loc.isFb"
           type="text"
           [(ngModel)]="loc.fbUrl"
           class="form-control">
    <br *ngIf="loc.isFb">


    <input *ngIf="loc.isTwitter"
           type="text"
           [(ngModel)]="loc.twitterUrl"
           class="form-control">
    <br *ngIf="loc.isTwitter">


    <input *ngIf="loc.isYelp"
           type="text"
           [(ngModel)]="loc.yelpUrl"
           class="form-control">
    <br *ngIf="loc.isYelp">


    <input *ngIf="loc.isGoogle"
           type="text"
           [(ngModel)]="loc.google"
           class="form-control">
    <br *ngIf="loc.isGoogle">


    <input *ngIf="loc.isLinkedIn"
           type="text"
           [(ngModel)]="loc.linkedIn"
           class="form-control">
    <br *ngIf="loc.isLinkedIn">


    <input *ngIf="loc.isInsta"
           type="text"
           [(ngModel)]="loc.insta"
           class="form-control">
    <br *ngIf="loc.isInsta">
  </div>
</div>
<div class="row"
     *ngIf="!isTypeform">
  <div *ngIf="loc.isOther"
       class="col-sm-2">
    <b>Other Social Media</b>
  </div>
  <div *ngIf="loc.isOther"
       class="col-sm-4">
    {{ loc.otherSocial }}
  </div>
</div>



// WEBPACK FOOTER //
// ./src/ng2/app/components/onboarding-location-view/onboarding-location-view.component.html